// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { GroupModel, PackageModel, PartModel } from "@store/Framework/Types/ApiModels";
import PartFinderListItem from "@store/Library/Components/PartFinder/PartFinderListItem";
import GetCollectiveProductContext from "@toolkit/Framework/Components/ProductContext/GetCollectiveProductContext";
import React, { ChangeEvent, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    group?: GroupModel;
    packageModel?: PackageModel;
}

const mapDispatchToProps = {
    loadProducts,
};

export interface PartFinderListGroupStyles {
    centeringWrapper?: InjectableCss;
}

export const partFinderListGroupStyles: PartFinderListGroupStyles = {
    centeringWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            height: 135px;
            justify-content: center;
            align-items: center;
        `,
    },
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

const styles = partFinderListGroupStyles;
const PartFinderListGroup = ({ loadProducts, group, packageModel }: Props) => {
    const [loadedProducts, setLoadedProducts] = useState<ProductModel[]>([]);
    const [hasNoOptiProducts, setHasNoOptiProducts] = useState(false);

    useEffect(() => {
        if (loadedProducts.length > 0) {
            return;
        }
        const ids = group?.parts?.reduce((acc: any[], part: any) => {
            if (part.id !== "00000000-0000-0000-0000-000000000000") {
                acc.push(part.id);
            }
            if (part.kitModels) {
                part.kitModels.forEach((kitModel: any) => {
                    if (kitModel.id !== "00000000-0000-0000-0000-000000000000") {
                        acc.push(kitModel.id);
                    }
                });
            }
            return acc;
        }, []);
        if (ids && ids.length > 0) {
            loadProducts({
                productIds: ids,
                onSuccess: (result: ProductModel[]) => {
                    setLoadedProducts(result);
                },
            });
        } else if (group?.parts && group?.parts.length > 0) {
            setHasNoOptiProducts(true);
        }

        return () => {
            setLoadedProducts([]);
        };
    }, [packageModel?.number]);

    const itemsLoop = (
        <>
            {group?.parts?.map((part: PartModel) => (
                <StyledWrapper
                    key={`${group.name}-${packageModel?.number}-${part.name}-${part.itemNumber}-${part.number}`}
                >
                    <PartFinderListItem
                        part={part}
                        packageModel={packageModel}
                        forceLoadInventory={false}
                        forceLoadPricing={false}
                    />
                    {part.kitModels?.map(kitPart => (
                        <PartFinderListItem
                            key={`kitmodel-${group.name}-${packageModel?.number}-${part.name}-${part.itemNumber}-${part.number}-${kitPart.name}-${kitPart.itemNumber}`}
                            packageModel={packageModel}
                            part={kitPart}
                            isKit={true}
                            forceLoadInventory={false}
                            forceLoadPricing={false}
                        />
                    ))}
                </StyledWrapper>
            ))}
        </>
    );

    if (group?.parts && group?.parts.length > 0) {
        if (hasNoOptiProducts) {
            return itemsLoop;
        }
        if (!loadedProducts || (loadedProducts && loadedProducts?.length < 1)) {
            return (
                <StyledWrapper {...styles.centeringWrapper}>
                    <LoadingSpinner />
                </StyledWrapper>
            );
        }
    }

    return (
        <GetCollectiveProductContext products={loadedProducts} loadInventory={true} loadPrice={true}>
            {itemsLoop}
        </GetCollectiveProductContext>
    );
};

export default connect(null, mapDispatchToProps)(PartFinderListGroup);
